import { render, staticRenderFns } from "./EntityTaskList.vue?vue&type=template&id=aa89bef6&scoped=true&"
import script from "./EntityTaskList.vue?vue&type=script&lang=js&"
export * from "./EntityTaskList.vue?vue&type=script&lang=js&"
import style0 from "./EntityTaskList.vue?vue&type=style&index=0&id=aa89bef6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa89bef6",
  null
  
)

export default component.exports